export default {"src":"/_next/static/media/investing.bcb406d1.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};